<template>
  <article>
    <header>
      <div class="container">
        <h1 class="about">Credits</h1>
      </div>
    </header>
    <main>
      <div class="container">
        <p class="body">Beyond School is a project by the Global Reporting Program. The GRP is based at the University of British Columbia's Graduate School of Journalism, Writing, and Media. This project was produced in partnership with the University of British Columbia, Centre for Excellence in Journalism in Karachi and Daystar University in Nairobi.</p>
        <p class="body">This project was made possible with generous funding from the Jonathan Logan Family Foundation. Additional funding and support provided by the University of British Columbia.</p>
        <h2>Culture - Norway</h2>
        <p><span>Written and Co-Produced by</span>Logan Turner</p>
        <p><span>Produced by</span>Britney Dennison and Kathryn Gretsinger</p>
        <p><span>Reporting by</span>Logan Turner, Fabian Fröhlich and Maria Jose Athie Martinez</p>
        <p><span>Script Editing by</span>Kathryn Gretsinger and Britney Dennison</p>

        <h2>Language - Nepal</h2>
        <p><span>Written by</span>Ben Mussett, Hina Imam, Braela Kwan and Alison St. Pierre</p>
        <p><span>Co-Produced by</span>Ben Mussett</p>
        <p><span>Produced by</span>Kathryn Gretsinger and Farah Nosh</p>
        <p><span>Reporting by</span>Ben Mussett, Hina Imam, Braela Kwan and Alison St. Pierre</p>
        <p><span>Journalism Partners in the Field</span>Niranjan Kunwar</p>
        <p><span>Script Editing by</span>Kathryn Gretsinger</p>
        <p><span>Translators</span>Sushma Srestha and Swasti Uprety</p>

        <h2>Inclusion - Kenya</h2>
        <p><span>Written and Co-Produced by</span>Kassidie Cornell and Candice Lipski</p>
        <p><span>Produced by</span>Kathryn Gretsinger, Mike Lakusiak and Bathseba Opini</p>
        <p><span>Reporting by</span>Kassidie Cornell, Candice Lipski, Lydia Mukari Okang’a, Drusilla Anyango and Nkurikiyinka Julien Astrida</p>
        <p><span>Script Editing by</span>Kathryn Gretsinger</p>
        <p><span>With Support from</span>Agnes Lucy Lando</p>

        <h2>Religion - Pakistan</h2>
        <p><span>Written by</span>Asim Muhammad Ameen</p>
        <p><span>Produced by</span>Kathryn Gretsinger, Muna Khan and Peter Klein</p>
        <p><span>Reporting by</span>Asim Muhammad Ameen, Rabia Bugti, Aria Nasimi and Rida E Zehra Zaidi</p>

        <h2>Digital</h2>
        <p><span>Design</span>Britney Dennison and Andrew Munroe</p>
        <p><span>Development</span>Andrew Munroe</p>
        <p><span>Story Editing by</span>Britney Dennison and Kathryn Gretsinger</p>
        <p><span>Additional Editing by</span>Andie Crossan</p>
        <p><span>Fact Checking</span>Amelia Williams and Sharon Nadeem</p>
        <p><span>Podcast Artwork</span>Esther Cheung</p>

      </div>
    </main>
  </article>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: 'Beyond School Credits',
      link: [{
        rel: 'canonical', href: 'https://globalreportingprogram.org/beyond-school/credits'
      }],
    }
  }
}
</script>

<style lang="scss">

.credits {
  article {
    padding: 2rem 1rem 2rem;
    h1 {
      font-size: 1.5rem;
      @include md { font-size: 1.9rem; }
      margin: 2rem 0 0.5rem;
    }
    h2 {
      font-size: 1.2rem;
      margin: 2.5rem 0 0.5rem;
      border-top: 1px solid rgb(206, 206, 206);
      padding-top: 2rem;
    }
    p.body {
      margin-bottom: 1.5rem;
    }
    p {
      margin-bottom: 0.5rem;
    }
    p span {
      font-size: 0.8em;
      margin-right: 0.75rem;
      font-style: italic;
    }
  }

}


</style>